import React, {useState, useEffect} from 'react';

const checkBox = (props) => {
  let errorMsg = '';
  const [isChecked, setIsChecked] = useState(props.isChecked);

  if (props.error && props.error.length > 0) {
    errorMsg = props.error;
  }

  const handelOnChange = (e, id) => {
   
    if (e.target.checked) {
      props.onCheck(id);
      setIsChecked(true);
    } else {
      props.onUncheck(id);
      setIsChecked(false);
    }
  };

  return (
    <div className='custom-control custom-checkbox'>
      <input
        onChange={(e) => {
          handelOnChange(e, props.id);
        }}
        type='checkbox'
        className='custom-control-input'
        checked={isChecked}
        id={props.id}
      />
      <label className='custom-control-label' htmlFor={props.id}>
        {props.label}
      </label>
      {errorMsg.length > 0}
      <div className='error'>{errorMsg}</div>
    </div>
  );
};

export default checkBox;
